const menuAboutEN = {
    "view": {
        "label": {
            "myProfile": "My Profile",
            "twoFactorAuthentication": "Two-Factor Authentication",
            "mySubscription": "My Subscription",
            "announcements": "Announcements",
            "mySubUsers": "My Sub-Users",
            "myLabels": "My Labels",
            "escrowWallet": "Escrow Wallet",
            "copyright": "Copyright Infringements",
            "financialStatements": "Financial Statements",
            "userStatements": "User Statements",
            "subuserStatements": "Subuser Statements",
            "invoices": "Invoices",
            "paymentMethods": "Payment Methods",
            "purchaseHistory": "Purchase History",
            "accessKeys": "Access Keys",
            "logout": "Logout"
        }
    }
};

export default menuAboutEN;